import { render, staticRenderFns } from "./ChallengePanel.vue?vue&type=template&id=481925a4&scoped=true&"
import script from "./ChallengePanel.vue?vue&type=script&lang=js&"
export * from "./ChallengePanel.vue?vue&type=script&lang=js&"
import style0 from "./ChallengePanel.vue?vue&type=style&index=0&id=481925a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481925a4",
  null
  
)

export default component.exports